module.exports = __webpack_public_path__ + "media/img/why/banner-main-eed801260ad14a0511c47ec8df5616ca.jpg";